import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import { colors } from '../color';
import { AlertFilled, AlertOutlined, PlusOutlined } from '@ant-design/icons';
import { FaCrosshairs } from 'react-icons/fa';
import { ServerIP, SiteUrl } from '../component/ServerIP';
import Loader from '../component/Loader';



const ClientVerifiedPickupMap = ({ }) => {

    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('orderId');
    const [loading, setLoading] = useState(false);
    const [startLoading, setStartLoading] = useState(true);
    const [starting, setStarting] = useState(false);


    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.42, lng: -72.57 };
    const [location, setLocation] = useState([18.32, -72.17]);
    const [zoom] = useState(12);



    useEffect(() => {
        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
            minZoom: 3,
            maxZoom: 20,
        });


        L.tileLayer('https://api.maptiler.com/maps/streets-v2/style.json?key=wpyZbJOc6hFpTL8ANsqV', {
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map.current);

        getPage();

        fetchNearbyMarker();

    }, [center.lat, center.lng, zoom]);


    //Alert

    const [alertMarker, setAlertMarker] = useState([]);
    const [oldAlertMarker, setOldAlertMarker] = useState([])
    const [showMarker, setShowMarker] = useState(true);


    function getColor(title) {
        switch (title) {
            case 'Tir':
                return 'rgba(255,0,0,0.5)';
            case 'Kidnapping':
                return 'rgba(230, 126, 34, 0.5)';
            case 'Blocked':
                return 'gray';
            default:
                return 'black';
        }
    }

    function getIcon(title) {
        switch (title) {
            case 'Tir':
                return L.icon({ iconUrl: require('../data/IconImageMap/gun.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Kidnapping':
                return L.icon({ iconUrl: require('../data/IconImageMap/child.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Blocked':
                return L.icon({ iconUrl: require('../data/IconImageMap/block1.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            default:
                return L.icon({ iconUrl: require('../data/IconImageMap/block.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
        }
    }

    function getRadius(title) {
        switch (title) {
            case 'Tir':
                return 400;
            case 'Kidnapping':
                return 600;
            case 'Blocked':
                return 100;
            default:
                return 100;
        }
    }


    const markersRef = useRef([]);
    const circlesRef = useRef([]);

    useEffect(() => {
        if (Array.isArray(alertMarker) && alertMarker.length > 0) {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];

            alertMarker.map((marker, index) => {
                if (marker.coordinate) {
                    const icon = getIcon(marker.title);
                    const markerInstance = L.marker([marker.coordinate.latitude, marker.coordinate.longitude], { icon }).addTo(map.current);
                    markerInstance.bindPopup(`${marker.title} - ${getTime(marker.createdAt)}`);

                    const circle = L.circle([marker.coordinate.latitude, marker.coordinate.longitude], { radius: getRadius(marker.title), fillColor: getColor(marker.title), fillOpacity: 0.2, color: getColor(marker.title) }).addTo(map.current);

                    // Ajoutez les instances de marqueurs et de cercles aux tableaux
                    markersRef.current.push(markerInstance);
                    circlesRef.current.push(circle);
                }
            });
        } else {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];
        }
    }, [alertMarker]);


    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }

    };

    const fetchNearbyMarker = async () => {

        await axios.get(`${ServerIP}/alert/getAlert`)
            .then(res => {

                setAlertMarker(res.data.alertMarker)
                setOldAlertMarker(res.data.alertMarker)
            })
    };

    const cancelShowMarker = () => {
        setShowMarker(false);
        setAlertMarker([])
    };

    const showMarkerFunc = () => {
        setShowMarker(true);
        setAlertMarker(oldAlertMarker);
    };



    //Coordinate

    const [marker, setMarker] = useState(null);
    const [markerPos, setMarkerPos] = useState(null);

    let userMarker = useRef();

    const getCoordinate = async () => {
        // setStarting(true)
        axios.get(`${ServerIP}/mission/getCoordinateMissionClient/${orderId}`)
            .then(res => {
                if (res.status === 200) {
                    // //pickup
                    // const userIcon2 = L.icon({ iconUrl: require('../data/IconImageMap/currentLocation.png'), iconSize: [25, 36], iconAnchor: [12, 35] });

                    // if (userMarker2.current) {
                    //     userMarker2.current.remove();
                    // }

                    // userMarker2.current = L.marker([res.data.pickupLatitude, res.data.pickupLongitude], { icon: userIcon2 }).addTo(map.current);


                    //delivered
                    setLocation([res.data.deliveredLatitude, res.data.deliveredLongitude]);

                    if (userMarker.current) {
                        userMarker.current.remove();
                    }

                    userMarker.current = L.marker([res.data.pickupLatitude, res.data.pickupLongitude], {
                        icon: L.icon({
                            iconUrl: require('../data/IconImageMap/riseHand.png'),
                            iconSize: [25, 40],
                            iconAnchor: [12, 36],
                        }),
                        draggable: false
                    }).addTo(map.current);

                    // userMarker.current.on('move', function (e) {
                    //     addressPosition = userMarker.current.getLatLng();
                    //     setMarkerPos(addressPosition);
                    // });

                    setMarker(userMarker.current);
                    // setMarkerPos(userMarker.current._latlng);
                    map.current.flyTo([res.data.pickupLatitude, res.data.pickupLongitude], map.current.getZoom() + 8);

                    // setTimeout(() => {
                    //           setStarting(false);
                    //       }, 10000);
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (map.current) {
            const centerMap = map.current.getCenter();
            setMarkerPos(centerMap);

            map.current.on('moveend', () => {
                const centerMap = map.current.getCenter();
                setMarkerPos(centerMap);
                // Mettez à jour l'état ou effectuez d'autres actions ici...
            });

            map.current.on('zoomend', () => {
                const centerMap = map.current.getCenter();
                setMarkerPos(centerMap);
                // Mettez à jour l'état ou effectuez d'autres actions ici...
            });
        }
    }, [center.lng, center.lat, zoom]);

    // Vérifiez que markerPos n'est pas null avant d'accéder à ses propriétés
    if (markerPos) {
        console.log(`Latitude: ${markerPos.lat}, Longitude: ${markerPos.lng}`);
    } else {
        console.log('markerPos est null ou undefined');
    }


    const confirmAddress = async () => {
        try {
            if (location.length !== 0 && starting !== true) {
                setLoading(true);

                const latitude = markerPos.lat;
                const longitude = markerPos.lng;

                // Geocoding inverse avec geocode.maps.co
                // const responseAddress = await axios.get(`https://geocode.maps.co/reverse`, {
                //   params: {
                //     lat: latitude,
                //     lon: longitude,
                //     api_key: process.env.REACT_APP_GEOCODING_API
                //   }
                // });

                const responseAddress = await axios.get(`https://api.locationiq.com/v1/reverse.php`, {
                    params: {
                        lat: latitude,
                        lon: longitude,
                        key: 'pk.9ae8e989ddeec759a4a56e6912ac9ac2',
                        format: 'json',
                    }
                });

                if (responseAddress.data) {
                    const { display_name } = responseAddress.data;

                    const data = {
                        latitude: markerPos.lat,
                        longitude: markerPos.lng,
                        addressPickup: display_name,
                    };

                    const response = await axios.patch(`${ServerIP}/mission/confirmMissionPickupAddress/${orderId}`, data);

                    if (response.status === 200) {
                        const response1 = await axios.get(`${ServerIP}/mission/getCoordinateMissionClient/${orderId}`);
                        if (response1.status === 200) {
                            setLoading(false);
                            map.current.flyTo([markerPos.lat, markerPos.lng], map.current.getZoom() + 1);
                            setTimeout(() => {
                                window.location.href = `${SiteUrl}/clientVerifiedDeliveredMap/?orderId=${orderId}`;
                            }, 500);
                        } else {
                            setLoading(false);
                            console.log(`Erreur lors de la récupération de l'adresse : ${response1.status}`);
                        }
                    } else {
                        setLoading(false);
                        console.log(`Erreur lors de la confirmation de l'adresse : ${response.status}`);
                    }
                } else {
                    setLoading(false);
                    console.log('Aucun résultat trouvé pour cette adresse.');
                }
            }
        } catch (error) {
            setLoading(false);
            console.log(`Une erreur est survenue : ${error.message}`);
        }
    };


    const getPage = async () => {
        axios.get(`${ServerIP}/mission/getPage/${orderId}`)
            .then(res => {
                if (res.status === 200) {
                    setStartLoading(false);
                    getCoordinate();
                } else if (res.status === 201) {
                    window.location.href = `${SiteUrl}/clientPaymentMap/?orderId=${orderId}`
                } else if (res.status === 202) {
                    window.location.href = `${SiteUrl}/clientRoutingMap/?orderId=${orderId}`
                } else if (res.status === 203) {
                    window.location.href = `${SiteUrl}/clientVerifiedDeliveredMap/?orderId=${orderId}`
                }
            }).catch(err => {
                setStartLoading(false);
                console.log(err)
            })
    }


    //Coordinate Position

    const userMarkerRef = useRef(null);
    const intervalIdRef = useRef(null);
    const firstCallRef = useRef(true);

    const getRealTimePositionFunc = async () => {
        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        if (!map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }
    }

    const getRealTimePosition = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 5000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);

            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            });

            if (!userMarkerRef.current) {
                userMarkerRef.current = L.marker([position.coords.latitude, position.coords.longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarkerRef.current.setLatLng([position.coords.latitude, position.coords.longitude]);
            }

            if (firstCallRef.current === true) {
                map.current.flyTo([latitude, longitude], map.current.getZoom());
                firstCallRef.current = false;
            }

        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };

    const [isPressed, setIsPressed] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    // if(startLoading === true){
    //     return(
    //         <div style={{ flex:1 , display:'flex' , alignItems: 'center',
    //                     justifyContent: 'center', backgroundColor:colors.white}}>
    //         <Loader visible={startLoading} />
    //         </div>
    //     )
    // }
    return (

        <div className="map-wrap">

            <div ref={mapContainer} className="map" style={{ zIndex: 0, top: 0, height: '80%' }} />


            <div style={{ width: '100%', height: '80%' }}>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 25,
                        top: '40%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        borderWidth: '1px',
                        backgroundColor: isPressed ? colors.white : colors.accent,
                        height: 50,
                        width: 50,
                        borderRadius: '50%',
                        display: 'flex',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.1s, background-color 0.1s',
                        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
                    }}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onClick={getRealTimePositionFunc}
                >
                    <FaCrosshairs size={20} color={colors.black} />
                </div>

                {showMarker ? (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 25,
                            top: '5%',
                            zIndex: 1,
                            borderWidth: '1px',
                            backgroundColor: 'white',
                            height: 50,
                            width: 50,
                            borderRadius: '50%',
                            boxShadow: '0 0 10px #fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={cancelShowMarker}
                    >
                        <AlertFilled style={{ color: colors.secondary }} />
                    </div>
                ) : (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 25,
                            top: '5%',
                            zIndex: 1,
                            borderWidth: '1px',
                            backgroundColor: 'white',
                            height: 50,
                            width: 50,
                            borderRadius: '50%',
                            boxShadow: '0 0 10px #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={showMarkerFunc}
                    >
                        <AlertOutlined style={{ color: colors.black }} />
                    </div>
                )}

                <div
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        bottom: 100,
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1,
                        height: 50,
                        width: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PlusOutlined style={{ color: colors.black, fontSize: '12px' }} />
                </div>

            </div>


            <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: '20%', bottom: 20, borderTopRightRadius: 15, borderTopLeftRadius: 15, backgroundColor: colors.white }}>

                <div style={{ height: '70%', width: '98%' }}>
                    <span style={{ display: 'flex', alignSelf: 'center', marginTop: '20px', textAlign: 'center', fontWeight: 700, fontFamily: 'Inter', color: 'gray', fontSize: 17 }}>
                        Placez le (+) à l'endroit où vous souhaitez que le chauffeur vous récupère.
                    </span>
                </div>


                {!loading ? (
                    <div
                        onClick={confirmAddress}
                        style={{
                            width: '90%', display: 'flex', marginLeft: '20px', marginRight: '20px',
                            alignItems: 'center', justifyContent: 'center', height: '55px', backgroundColor: "#C0EC4E", borderRadius: '35px',
                            fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 16
                        }}>
                        Confirmer
                    </div>
                ) : (
                    <div
                        onClick={() => { }}
                        style={{
                            width: '90%', display: 'flex', marginLeft: '20px', marginRight: '20px',
                            alignItems: 'center', justifyContent: 'center', height: '55px', backgroundColor: "#C0EC4E", borderRadius: '35px',
                            fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 16
                        }}>
                        Chargement...
                    </div>
                )}


            </div>

            <Loader visible={isVisible} />

        </div >
    )

}

export default ClientVerifiedPickupMap;


